import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { UAParser } from 'ua-parser-js'

export const useGameStore = defineStore('game', () => {
  // State
  const base = ref('/')
  const isLastPage = ref(false)
  const isLoadingMore = ref(false)
  const room = ref(null)
  const index = ref(-1)
  const content = ref({
    data: [],
    timestamp: null,
    parentCategoryId: null,
    totalPage: 0,
  })
  const additionEnable = ref(false)
  const addition = ref({
    data: [],
    timestamp: null,
    totalPage: 0,
  })
  const game = ref({
    providerId: null,
    gameId: null,
    gameTypeId: null,
    mappingId: null,
    portrait: null,
    gameCode: null,
    name: null,
    isDemo: false,
  })
  const walletType = ref(null)
  const lang = ref('en_US')
  const isMobile = ref(new UAParser().getResult().device.type)
  const gameURL = ref(null)
  const gameToken = ref(null)
  const gameHtml = ref(null)
  const gameType = ref(null)
  const gameWalletType = ref(null)
  const isPlaying = ref(false)
  const gameStatus = ref('idle')

  // Getters
  const hasNext = computed(() => {
    return !isLastPage.value
  })

  const hasRoomAndIsNotInGame = computed(() => {
    return room.value?.categoryId && !isPlaying.value
  })

  const getBase = computed(() => base.value)

  // Actions
  function setBase(value) {
    base.value = value
  }

  function setIsLastPage(value) {
    isLastPage.value = value
  }

  function setIsLoadingMore(value) {
    isLoadingMore.value = value
  }

  function setRoom(value) {
    room.value = value
  }

  function setIndex(value) {
    index.value = value
  }

  function setContent(value) {
    content.value = value
  }

  function setAdditionEnable(value) {
    additionEnable.value = value
  }

  function setAddition(value) {
    addition.value = value
  }

  function setGame(value) {
    game.value = value
  }

  function setWalletType(value) {
    walletType.value = value
  }

  function setLang(value) {
    lang.value = value
  }

  function setIsMobile(value) {
    isMobile.value = value
  }

  function setGameURL(value) {
    gameURL.value = value
  }

  function setGameToken(value) {
    gameToken.value = value
  }

  function setGameHtml(value) {
    gameHtml.value = value
  }

  function setGameType(value) {
    gameType.value = value
  }

  function setGameWalletType(value) {
    gameWalletType.value = value
  }

  function setIsPlaying(value) {
    isPlaying.value = value
  }

  function setGameStatus(value) {
    gameStatus.value = value
  }

  function increaseIndex() {
    index.value += 1
  }

  function resetContent() {
    isLastPage.value = false
    index.value = -1
    content.value = {
      data: [],
      timestamp: null,
      parentCategoryId: null,
      totalPage: 0,
    }
    addition.value = {
      data: [],
      timestamp: null,
      totalPage: 0,
    }
  }

  function clearGameInfo() {
    game.value = {
      providerId: null,
      gameId: null,
      gameTypeId: null,
      mappingId: null,
      portrait: null,
      gameCode: null,
      name: null,
      isDemo: false,
    }
    gameURL.value = null
    gameToken.value = null
    gameHtml.value = null
    gameType.value = null
    gameWalletType.value = null
  }

  return {
    // State
    base,
    isLastPage,
    isLoadingMore,
    room,
    index,
    content,
    additionEnable,
    addition,
    game,
    walletType,
    lang,
    isMobile,
    gameURL,
    gameToken,
    gameHtml,
    gameType,
    gameWalletType,
    isPlaying,
    gameStatus,
    // Getters
    hasNext,
    hasRoomAndIsNotInGame,
    getBase,
    // Actions
    setBase,
    setIsLastPage,
    setIsLoadingMore,
    setRoom,
    setIndex,
    setContent,
    setAdditionEnable,
    setAddition,
    setGame,
    setWalletType,
    setLang,
    setIsMobile,
    setGameURL,
    setGameToken,
    setGameHtml,
    setGameType,
    setGameWalletType,
    setIsPlaying,
    setGameStatus,
    increaseIndex,
    resetContent,
    clearGameInfo,
  }
})
